import React from "react";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";

export const HomePage: React.FC = () => <ServiceCataloguePageWrapper title="Home Page" />;
